import { render, staticRenderFns } from "./StempelEditBDE.vue?vue&type=template&id=2ec79156"
import script from "./StempelEditBDE.vue?vue&type=script&lang=ts"
export * from "./StempelEditBDE.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports